<div class="part-header">
  <ng-content select="wz-form-group-part-header"></ng-content>
</div>
<div class="part-content">
  <ng-content></ng-content>
</div>
